import {
  Question,
  PlaceOrderFormData,
  AdvancedFormSubmissionData,
  OrderData,
  AdvancedFormSubmissionAnswer,
  PdfUploadFieldValue,
} from "types"

const collectAllQuestions = (questions: Question[]) => {
  const allQuestions: Question[] = []

  questions.forEach((question) => {
    allQuestions.push(question)

    // If this is a branching question, collect nested questions
    if (question.choices) {
      question.choices.forEach((choice) => {
        if (choice.question_branch && choice.question_branch.length > 0) {
          // Add all branch questions directly (no nested branching)
          allQuestions.push(...choice.question_branch)
        }
      })
    }
  })

  return allQuestions
}

export const transformAdvancedFormData = (
  formData: PlaceOrderFormData,
  orderData: OrderData,
  questionsByTicketType: Map<number, Question[]>
): AdvancedFormSubmissionData => {
  const transformedData: AdvancedFormSubmissionData = {
    first_name: formData.contactInfo.firstName,
    last_name: formData.contactInfo.lastName,
    email: formData.contactInfo.email,
    answers: {},
  }

  orderData.ticket_set.forEach((ticket) => {
    const ticketAnswers = formData.tickets[ticket.id] || {}
    const questions =
      questionsByTicketType.get(ticket.ticket_type_published) || []

    if (!ticketAnswers && !formData.contactInfo) {
      console.warn(`No form data found for ticket ID ${ticket.id}`)
      return
    }

    // Collect all questions including branch questions
    const allQuestions = collectAllQuestions(questions)

    // Process all answered questions
    transformedData.answers[ticket.id] = allQuestions
      .map((question) => {
        const fieldValue = ticketAnswers[question.uuid]

        if (!fieldValue) return null

        let submission: AdvancedFormSubmissionAnswer | null = {
          question_published_uuid: question.uuid,
          question_type: question.question_type,
        }

        if (question.question_type === "multiple-choice") {
          const answerIds = Array.isArray(fieldValue) ? fieldValue : []
          if (answerIds.length > 0) {
            submission.multi_choice_published_answer_ids = answerIds
          } else {
            submission = null
          }
        } else if (question.question_type === "pdf") {
          if (typeof fieldValue === "object" && fieldValue !== null) {
            const pdf = fieldValue as PdfUploadFieldValue
            submission.pdf_ids = [pdf.id]
          } else {
            submission = null
          }
        } else {
          submission.answer = String(fieldValue)
        }
        return submission
      })
      .filter((answer) => answer !== null) as AdvancedFormSubmissionAnswer[]
  })

  return transformedData
}
